import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fileExt } from "@/components/grc/EvidenceVault";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Skeleton } from "@/components/ui/skeleton";

export const EvidencePreviewModal = ({ item, open, onClose }) => {
  const [url, setUrl] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let objectUrl = null;
    if (open && item) {
      setUrl(null);
      setError(false);
      api.get(`/grc/evidence/${item.file_id}/download`, { responseType: "blob" })
        .then((res) => {
          objectUrl = URL.createObjectURL(res.data);
          setUrl(objectUrl);
        })
        .catch(() => setError(true));
    }
    return () => {
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [open, item]);

  const ext = fileExt(item?.filename);
  const isImage = ["png", "jpg", "jpeg"].includes(ext);

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="sm:max-w-3xl max-h-[90vh]" data-testid="evidence-preview-modal">
        <DialogHeader>
          <DialogTitle className="text-base text-[#003366] truncate">{item?.filename}</DialogTitle>
          <DialogDescription className="text-xs">Evidence preview</DialogDescription>
        </DialogHeader>
        <div className="min-h-[300px] flex items-center justify-center">
          {error ? (
            <p className="text-xs text-red-500" data-testid="evidence-preview-error">Failed to load preview</p>
          ) : !url ? (
            <Skeleton className="w-full h-[400px] rounded-lg" />
          ) : isImage ? (
            <img src={url} alt={item?.filename} className="max-h-[65vh] max-w-full object-contain rounded-lg" data-testid="evidence-preview-image" />
          ) : (
            <iframe src={url} title={item?.filename} className="w-full h-[65vh] rounded-lg border border-slate-200" data-testid="evidence-preview-pdf" />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
